import React,{useState,useEffect} from "react"
import {useStaticQuery, graphql} from 'gatsby'
import { getImage } from 'gatsby-plugin-image'
import {fontColorWhite,whiteLink,center,fontFaceBarlow} from './shared.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleChevronDown,faCircleChevronUp } from '@fortawesome/free-solid-svg-icons'
import CorporateMenuLinks from './corporateMenuLinks'
import { navigate } from "gatsby"

const HomePageTop = ({image,onLocationChange})=>{

    const [selected, setSelected] = useState(0)
    const [pickList, setPickList] = useState(false)
    const [locations, setLocations] = useState(['Ann Arbor, MI','Ypsilanti, MI','Winter Park, FL','Orlando, FL']);
    const [drpdwnWidth, setErpdwnWidth] = useState({'Ann Arbor, MI':'341px','Ypsilanti, MI': '318px','Winter Park, MI':'365px','Orlando, FL':'309px'});
    const [menuClicked, setMenuClicked] = useState(false)

    const searchLink = ()=>{
        let l = [{'Ann Arbor, MI':'michigan:ann-arbor'},{'Ypsilanti, MI':'michigan:ypsilanti'},{'Winter Park, FL':'florida:winter-park'},{'Orlando, FL':'florida:orlando'}];
        for(const x in l){
            let lk = Object.keys(l[x])[0];
            if(lk == locations[selected]){
                let sc = l[x][lk].split(':');
                let state = sc[0];
                let city = sc[1];
                //window.location.href = '/search?city='+city+'&state='+state;
                navigate(`/apartments/${state}/${city}/`);
            }
        }
    }

    const scrollLocation = ()=>{
        let tmp = selected + 1;
        if(tmp >= locations.length){
            tmp = 0;
        }
        setSelected(tmp);
    }

    const pickLocation = (pn)=>{
        setSelected(pn);
        setPickList(false);
        // inform parent of city change; map display labels to slugs
        const cityMap = {
            'Ann Arbor, MI': 'ann-arbor',
            'Ypsilanti, MI': 'ypsilanti',
            'Winter Park, FL': 'winter-park',
            'Orlando, FL': 'orlando'
        }
        if (typeof onLocationChange === 'function') {
            onLocationChange(cityMap[locations[pn]]);
        }
    }

    useEffect(() => {
        // Get user's geolocation
        if ("geolocation" in window.navigator) {
          window.navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;

              // Use latitude and longitude to determine the user's location
              const userLocation = determineUserLocation(latitude, longitude);
              //set default location
              setSelected(userLocation);
            },
            (error) => {
              console.error("Error getting geolocation:", error);
              if (error.code === error.PERMISSION_DENIED) {
                console.error("Location permission denied");
                // Automatically expand the dropdown list if permission is denied
                setPickList(true);
              }
            }
          );
        }
      }, []);
      
    // Notify parent component when selected location changes
    useEffect(() => {
        const cityMap = {
            'Ann Arbor, MI': 'ann-arbor',
            'Ypsilanti, MI': 'ypsilanti',
            'Winter Park, FL': 'winter-park',
            'Orlando, FL': 'orlando'
        }
        if (typeof onLocationChange === 'function') {
            onLocationChange(cityMap[locations[selected]]);
        }
    }, [selected, locations, onLocationChange]);

     const determineUserLocation = (latitude, longitude) => {
        latitude = Math.round(latitude);
        longitude = Math.round(longitude);
        // For simplicity, let's assume a basic implementation using latitude and longitude ranges
        if (latitude >= 25 && latitude <= 31 && longitude >= -87 && longitude <= -79) {
          // User is in Florida
          //return "Orlando, FL";
          return 3;
        } else if (latitude >= 41 && latitude <= 43 && longitude >= -85 && longitude <= -83) {
          // User is in Michigan
          //return "Ann Arbor, MI";
          return 0;
        } else {
          // Default location if the user's location is not within the defined ranges
          return 0;
        }
      };


    return(
        <div className="top-wrap" style={{backgroundImage:'url('+image+')',backgroundSize:'cover',backgroundPosition:'center calc(50% + 0px)',backgroundRepeat: 'no-repeat'}}>
        <div style={{background:'rgba(0,0,0,0.5)'}}>
        <section className="nav-wrap" style={{padding:'2rem'}}>
            <div className="container">
                <div className="columns">
                    <div className="column">
                        <nav className="navbar is-transparent" role="navigation" aria-label="main navigation" style={{backgroundColor: 'transparent'}}>
                          <div className="navbar-brand">
                              <a className="navbar-item" href="/">
                                    <img src="/imgs/mcklogo.png" alt="A McKinley Property" />
                                </a>
                              <a role="button" className="navbar-burger" 
                                  aria-label="menu" 
                                  aria-expanded="false" 
                                  onClick={()=>{setMenuClicked(!menuClicked)}}
                                  data-target="navbarMenu">
                                  <span aria-hidden="true"></span>
                                  <span aria-hidden="true"></span>
                                  <span aria-hidden="true"></span>
                              </a>
                          </div>
                            <div className={menuClicked ? "navbar-menu is-active" : "navbar-menu "}>
                              <div className="navbar-start">
                              </div>
                                <CorporateMenuLinks menuClicked={menuClicked}/>
                          </div>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
        <section className=" hero" id="home_page_hero" style={{ height:'68vh', minHeight: '450px',maxHeight:'600px' }}>
            <div className=" container hero-body" style={{width:'100%'}}>
                <div className="columns" style={{width:'100%',height:'100%'}}>
                    <div className={center+" column"} style={{position:'absolute',width:'100%',top:'40%',left:'50%', transform:'translate(-50%, -50%)', maxWidth:'960px'}}>
                        <h1 className={fontColorWhite+" "+fontFaceBarlow} style={{fontSize: '2.5rem'}}><span className="do-translate">Find your next apartment home in</span> <span style={{textDecoration:'underline'}} className="do-not-translate">{locations[selected]}</span>
                            <span style={{cursor:'pointer'}} onClick={()=>{setPickList(!pickList)}} className="do-not-translate"> <FontAwesomeIcon icon={pickList ? faCircleChevronUp : faCircleChevronDown} /> </span>
                        </h1>
                        {pickList &&  <div style={{
                            textAlign: 'left',
                            position: 'absolute',
                            right: '2.5rem',
                            background: 'linear-gradient(to bottom, rgba(10, 10, 10, 0), rgba(10, 10, 10, 0.8))',
                            width: '300px',
                            zIndex: 100,
                            padding: '1rem',
                            borderRadius: '0rem 0rem 1rem 1rem'
                        }} id="picklist" className="do-not-translate">
                            {locations.map((l,i)=>{
                                if(l != locations[selected]){
                                    return <p key={i} className={fontColorWhite+" "+fontFaceBarlow} onClick={()=>{pickLocation(i)}} style={{cursor:'pointer', fontSize: '1.5rem'}}>{l}</p>
                                }
                            })}
                        </div>

                        }                        <br />
                        <button className={`hero-search-${locations[selected].toLowerCase().replace(/[\s,]+/g, '')} button is-rounded is-large`} style={{fontSize: '1.2rem', zIndex: 100, position: 'relative'}} onClick={searchLink}>search</button>
                    </div>
                </div>
            </div>
        </section>
        </div>
        </div>
    )
}


export default HomePageTop
